module.exports = __webpack_public_path__ + "static/media/flower-allo-projects-alt.3c93ab89.png";